import { VOLOP_IMPORTED_TYPE_MAP } from './volopImportedTypeMap';

export const VOLOP_SOURCES = {
  ...VOLOP_IMPORTED_TYPE_MAP,
  IDEALIST: 'Idealist',
};
